import { render, staticRenderFns } from "./baseInformation.vue?vue&type=template&id=5e60ef2f&"
import script from "./baseInformation.vue?vue&type=script&lang=js&"
export * from "./baseInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports